import { action, createAsyncAction } from 'typesafe-actions';

import * as types from './types';
import { repositories } from 'api';
import { BasicApiException } from 'common/types';

export const addToShopCart = (
    {
        code,
        type,
        slug,
        price,
        name,
        images,
        minQuantity,
        taxAmount,
    }: repositories.products.CollectionTypes.ProductsItemType,
    quantity: number = 1,
    callback = () => {},
) =>
    action(
        types.ADD_TO_SHOP_CART,
        {
            code,
            quantity,
            details: {
                name,
                type,
                slug,
                price,
                images,
                minQuantity,
                taxAmount,
            },
        },
        { callback },
    );

export const changeProductQuantity = (code: string, quantity: number = 1, id: number) =>
    action(types.CHANGE_PRODUCT_QUANTITY, {
        code,
        quantity,
        id,
    });

export const removeItemFromShopCart = (id: number, quantity: number = 1) =>
    action(types.REMOVE_ITEM_FROM_SHOP_CART, {
        id,
        quantity,
    });

export const addPromotionalSet = (data: any, callback: Function) =>
    action(types.ADD_PROMOTIONAL_SET, {
        data
    }, { callback });

export const cartsPost = createAsyncAction(
    types.CARTS_POST_REQUEST,
    types.CARTS_POST_SUCCEEDED,
    types.CARTS_POST_FAILED,
)<never, any, any>();

type CartItem = {
    productCode: string;
    quantity: number;
    callback: Function;
};

export const cartItemsPost = createAsyncAction(
    types.CART_ITEMS_POST_REQUEST,
    types.CART_ITEMS_POST_SUCCEEDED,
    types.CART_ITEMS_POST_FAILED,
)<CartItem, any, BasicApiException<{ quantity: Array<string> }>>();

export const cartItemDelete = createAsyncAction(
    types.CART_ITEM_DELETE_REQUEST,
    types.CART_ITEM_DELETE_SUCCEEDED,
    types.CART_ITEM_DELETE_FAILED,
)<number, any, any>();

export const cartItemQuantity = createAsyncAction(
    types.CART_ITEM_QUANTITY_REQUEST,
    types.CART_ITEM_QUANTITY_SUCCEEDED,
    types.CART_ITEM_QUANTITY_FAILED,
)<any, any, any>();

export const cartPromotionalSet = createAsyncAction(
    types.CART_PROMOTIONAL_SET_REQUEST,
    types.CART_PROMOTIONAL_SET_SUCCEEDED,
    types.CART_PROMOTIONAL_SET_FAILED,
)<any, any, any>();

export const fetchCart = createAsyncAction(
    types.FETCH_CART_REQUEST,
    types.FETCH_CART_SUCCEEDED,
    types.FETCH_CART_FAILED,
)<never, any, any>();
